import { defaultOptions, API_URL } from "./fetchOptions";
import { V1Res } from "./interfaces";
import * as V1Types from "./types/sensor";

export const getAllUnitsAvgReadings = (
  args: V1Types.AvgSensorDataRequestProps
): Promise<V1Res<V1Types.DataRequestResp>> => {
  return fetch(
    `${API_URL}/v1/sensor/all/${args.sensorType}?period=${args.period}`,
    defaultOptions()
  ).then((res) => res.json());
};

export const getUnitReadings = (
  args: V1Types.UnitDataRequestProps
): Promise<V1Res<V1Types.DataRequestResp>> => {
  return fetch(
    `${API_URL}/v1/sensor/${args.device_id}/${args.sensorType}?period=${args.period}`,
    defaultOptions()
  ).then((res) => res.json());
};
